import { render, staticRenderFns } from "./PettycashBasicServices.vue?vue&type=template&id=5cdd68bc&scoped=true"
import script from "./PettycashBasicServices.vue?vue&type=script&lang=js"
export * from "./PettycashBasicServices.vue?vue&type=script&lang=js"
import style0 from "./PettycashBasicServices.vue?vue&type=style&index=0&id=5cdd68bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cdd68bc",
  null
  
)

export default component.exports